import Navbar from '@/components/layout/Navbar';
import Hero from '@/components/sections/Hero';
import Features from '@/components/sections/Features';
import HowItWorks from '@/components/sections/HowItWorks';
import AISearch from '@/components/sections/AISearch';
import CourtAccounts from '@/components/sections/CourtAccounts';
import PortalIntegration from '@/components/sections/PortalIntegration';
import Pricing from '@/components/sections/Pricing';
import FAQ from '@/components/sections/FAQ';
import Footer from '@/components/layout/Footer';

function App() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <Features />
        <HowItWorks />
        <AISearch />
        <CourtAccounts />
        <PortalIntegration />
        <Pricing />
        <FAQ />
      </main>
      <Footer />
    </>
  );
}

export default App;
